import axios from "axios";

/**
 * Consulta los datos del tablero de soportes históricos
 * @param {Object} data - Datos de búsqueda
 * @returns {Promise<Array>} Lista de registros obtenidos
 */

export async function getConsultAll(data) {
  try {
    const response = await axios.post("/Parametros/Plantillas/Get", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getConsecutivo(data) {
  try {
    const response = await axios.get("/Parametros/Plantillas/Consecutivo");
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getPlantillaEspecifica(data) {
  try {
    const response = await axios.get(
      "/Parametros/Plantillas/getPlantillaEspecifica/" + data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function postInsert(data) {
  try {
    const response = await axios.post("/Parametros/Plantillas/Post/", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function putUpdate(data) {
  try {
    const response = await axios.put("/Parametros/Plantillas/Put/", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function Delete(data) {
  try {
    const response = await axios.delete("/Parametros/Plantillas/Delete", {
      data,
    });
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}
